import ApiConfig from '../config/data/endpoints/index'
import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'

import { request } from './requestService'
import MockService from './mock/mockService'
const mockService = MockService()

// Private service methods

/**
 * Description
 * @param {object} options={} Config of request (url params, query params, etc.)
 * @param {object} config={} Endpoin config
 * @returns {object} Generated payload for requestService
 */
function _generateRequestPayload(options = {}, config = {}) {
	const ownOptionsProps = ['urlParams', 'params']
	const { url } = config
	const { urlParams } = options
	let queryUrl = import.meta.env.VITE_APP_BACK_API_URL + url

	// Transform endpoint URL path? with dynamic props
	// RISK(RISK-032)[S3/безопасность]: значение urlParams подставляется в путь без encodeURIComponent —
	// спецсимволы портят URL / позволяют инъекцию в путь. Ниже body формируется «по остатку» options.
	// Решение: encodeURIComponent для значений, явное формирование тела. docs/audit/04_risks_register.md (RISK-032)
	if (urlParams) {
		queryUrl = Object.entries(urlParams).reduce((processingUrl, [paramName, paramValue]) => {
			processingUrl = processingUrl.replace(`:${paramName}`, paramValue)

			return processingUrl
		}, queryUrl)
	}

	// Create payload for requestService, and delete props only for this method from options object param
	const payloadOptions = {
		url: queryUrl,
		params: options?.params || {},
		body: Object.fromEntries(
			Object.entries(options).filter(([propName]) => !ownOptionsProps.includes(propName)),
		),
		...(config.requestOptions || {}),
	}

	return payloadOptions
}

/**
 * Description
 * @param {object} options={} Config of request (url params, query params, etc.)
 * @param {object} config={} Endpoin config
 * @returns {Promise} Call of requestService, which returns request promise
 */
function _createRequest(options = {}, config = {}) {
	const requestPayload = _generateRequestPayload(options, config)

	return request(requestPayload)
}

/**
 * Description
 * @param {string} moduleName Name of module in config object
 * @param {string} endpointName Name of endpoint config in module
 * @returns {object, boolean} Endpoint config object \ false if not found config
 */
function _getApiConfig(moduleName, endpointName) {
	const moduleConfig = ApiConfig?.[moduleName]

	return moduleConfig && moduleConfig?.[endpointName]
}

/**
 * Description
 * @param {string} moduleName Name of module in config object
 * @param {string|object} endpointNameOrConfig Name of endpoint config in module OR object of config
 * @param {object} options={} Config of request (url params, query params, etc.)
 * @param {object} [options.urlParams] - urlParams
 * @param {object} [options.params] - params
 * @param {object} [options.body] - body
 * @returns {Promise}
 */
export function _apiRequestWrap(moduleName, endpointNameOrConfig, options = {}) {
	const config =
		typeof endpointNameOrConfig === 'string'
			? _getApiConfig(moduleName, endpointNameOrConfig)
			: endpointNameOrConfig

	if (!config) {
		return Promise.reject({
			message: `The is no such config for this request or method. (Module name: ${moduleName}. Endpoint name: ${endpointNameOrConfig})`,
		})
	}

	// Check the mock flag in config
	/* WARNING! Если передали конфиг вместо имени ссылки на конфиг - то мок не поддерживается! */
	if (config.mock) {
		const mockOptions = {
			moduleName: moduleName,
			mockName: endpointNameOrConfig,
			mockMethodName: config.mockMethodName,
			request: options,
		}

		return mockService.getMock(mockOptions)
	}

	return [config, _createRequest(options, config)]
}

// Private methods
function _getCacheHashes(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CACHE,
		ModulesConfigMap[ModulesMap.CACHE].GET_CACHE_HASHES,
		options,
	)
}

// USER module
function _getUserData(options = {}) {
	return _apiRequestWrap(ModulesMap.USER, ModulesConfigMap[ModulesMap.USER].GET_DATA, options)
}

function _getCacheVersions(options = {}) {
	return _apiRequestWrap(
		ModulesMap.USER,
		ModulesConfigMap[ModulesMap.USER].GET_CACHE_VERSION,
		options,
	)
}

import mapsApi from './apiServiceModules/mapsApi'

// AUTH module
import authApi from './apiServiceModules/authApi'
// PRESETS module
import presetsApi from './apiServiceModules/presetsApi'
// USER module
import userApi from './apiServiceModules/userApi'
// COMPANY module
import companyApi from './apiServiceModules/companyApi'

export default function () {
	function getCacheHashes(options = {}) {
		return _getCacheHashes(options)
	}
	function getUserData(options = {}) {
		return _getUserData(options)
	}

	function getCacheVersions(options = {}) {
		return _getCacheVersions(options)
	}

	return {
		getCacheHashes,
		getUserData,
		getCacheVersions,
		...mapsApi,
		...presetsApi,
		...authApi,
		...userApi,
		...companyApi,
	}
}
